export function isStandaloneMode(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const displayModeStandalone = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;

  return displayModeStandalone || iosStandalone;
}
